import { HelpText } from "../help-text";
import { Label } from "../label";
import { useInput, UseInputProps } from "./use-input";

export type InputProps = UseInputProps;

export const Input = (props: InputProps) => {
  const {
    className,
    styles,
    fieldId,
    label,
    hideLabel,
    hasError,
    errorMessage,
    color,
    componentProps,
  } = useInput(props);

  return (
    <div className={styles.base({ className })}>
      {!!label && (
        <Label
          htmlFor={fieldId}
          hidden={hideLabel}
          color={color}
          className={styles.label()}
        >
          {label}
        </Label>
      )}
      <div className={styles.group()}>
        <input id={fieldId} className={styles.input()} {...componentProps} />
      </div>
      {hasError && <HelpText status="danger">{errorMessage}</HelpText>}
    </div>
  );
};
